import React from 'react';
import { IonModal, IonIcon, IonToast, isPlatform } from '@ionic/react';
import {
  informationCircleOutline,
  settingsOutline,
  eye,
  bookmarks,
  warning,
} from 'ionicons/icons';
import noImageSvg from '../../../../images/noImage.svg';
import navSvg from '../../../../assets/uicons/svg/fi-ts-gps-navigation.svg';
import walletSvg from '../../../../images/wallet.svg';
import whatsappSvg from '../../../../images/whatsapp.svg';
import googleMapsSvg from '../../../../images/googleMaps.svg';
import './PropertyModal.css';

interface PropertyModalProps {
  isOpen: boolean;
  onClose: () => void;
  landAddress: string;
  isAdmin: boolean;
  isOperation: boolean;
  isUser: boolean;
  authenticationState: string;
  propertyAdvertisements: any[];
  property: any;
  buildingWalletSingle: boolean;
  onInfoClick: () => void;
  onLandOperationsClick: () => void;
  onWhatsAppClick: () => void;
  onGoogleMapsClick: () => void;
  onFavoriteClick: () => void;
  onNavigationClick: () => void;
  onWalletClick: () => void;
  onAdvertisementClick: (item: any) => void;
  onSignInClick: () => void;
  onCreateFavoriteLandClick: () => void;
  onCreateBuildingsWalletClick: () => void;
  NumberWithCommas: (num: number) => string;
  getPolygonCenterPoint: (geometry: any) => any;
  showOnGoogleMapsFunction: (coords: any) => void;
  handleStyleButtonByLandTypes: (landType: string) => any;
  routeLayer: any;
  addStop: (event: any) => void;
  currentEventClick: any;
  setIsLoading: (loading: boolean) => void;
  routeParams: any;
}

const PropertyModal: React.FC<PropertyModalProps> = ({
  isOpen,
  onClose,
  landAddress,
  isAdmin,
  isOperation,
  isUser,
  authenticationState,
  propertyAdvertisements,
  property,
  buildingWalletSingle,
  onInfoClick,
  onLandOperationsClick,
  onWhatsAppClick,
  onGoogleMapsClick,
  onFavoriteClick,
  onNavigationClick,
  onWalletClick,
  onAdvertisementClick,
  onSignInClick,
  onCreateFavoriteLandClick,
  onCreateBuildingsWalletClick,
  NumberWithCommas,
  getPolygonCenterPoint,
  showOnGoogleMapsFunction,
  handleStyleButtonByLandTypes,
  routeLayer,
  addStop,
  currentEventClick,
  setIsLoading,
  routeParams
}) => {
  return (
    <>
      <IonToast
        isOpen={isOpen && !buildingWalletSingle}
        message="نأمل مطابقة الموقع أدناه مع الموقع المذكور في وصف موقع العقار المذكور"
        position="top"
        color="warning"
        icon={warning}
        cssClass={`warning-toast ${isPlatform("ios") ? "py-6" : "py-4"}`}
      />
      <IonModal
        id="propertyModal"
        isOpen={isOpen && !buildingWalletSingle}
        backdropDismiss={true}
        onWillDismiss={onClose}
        trigger="open-custom-dialog"
      >
        <div className="wrapper">
          <div className="w-full flex-col justify-start items-center py-2 px-6">
            <div className="w-full flex flex-col justify-start items-center">
              <div className="w-full flex flex-row justify-between items-center">
                <div className="flex flex-col justify-start items-start">
                  <p className="font-bold text-darkBlue text-xl w-64 animate__animated animate__fadeInRight">
                    {landAddress}
                  </p>
                </div>

                <div className="flex flex-col justify-center items-center animate__animated animate__fadeInLeft">
                  <div className="flex flex-col gap-2">
                    <IonIcon
                      icon={informationCircleOutline}
                      style={{ height: "35px", color: "#17a2b8" }}
                      onClick={onInfoClick}
                      className="cursor-pointer"
                    />
                    {isAdmin || isOperation ? (
                      <IonIcon
                        icon={settingsOutline}
                        style={{ height: "35px", color: "#dc3545" }}
                        onClick={onLandOperationsClick}
                        className="cursor-pointer"
                      />
                    ) : null}
                  </div>
                </div>
              </div>

              {propertyAdvertisements.length == 0 ? (
                <div className="w-full bg-bkColor rounded border-[1px] border-paragraphColor flex flex-row justify-center items-center py-4 mt-4 animate__animated animate__fadeInUp">
                  <p className="font-medium text-paragraphColor text-sm">
                    لا توجد اعلانات على هذا العقار
                  </p>
                </div>
              ) : (
                <div className="flex flex-col justify-start item-start w-full">
                  <p className="font-bold text-primaryColor100 text-xl mt-2 animate__animated animate__fadeInRight">
                    اعلانات القطعة
                  </p>
                  {propertyAdvertisements.length > 1 && (
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "15px",
                        color: "#0031c4",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span>
                        &#8594; اسحب يمين او يسار لتبديل الإعلان &#8592;
                      </span>
                    </div>
                  )}
                  <div className="w-full flex flex-row justify-start items-center animate__animated animate__wobble">
                    <div
                      className={`flex space-x-3`}
                      style={{
                        overflow:
                          propertyAdvertisements.length > 1
                            ? "auto"
                            : "unset",
                      }}
                    >
                      <div
                        className={`flex flex-shrink-0 ${propertyAdvertisements.length == 1 && "w-full"
                          } overflow-x-auto flex space-x-4 p-2 ${propertyAdvertisements.length > 1 && "pr-0"
                          }`}
                        id="scrollContainer"
                      >
                        {propertyAdvertisements
                          .map((item: any, index: any) => (
                            <div
                              key={`${item.adLicenseNumber}-${item.idType}-${item.id}-${index}`}
                              className={`${propertyAdvertisements.length > 1 && "w-max"
                                } bg-[#fbfbff] rounded border-[1px] border-[transparent] flex flex-row justify-start items-start mt-2 shadow-md ml-2 cursor-pointer`}
                              onClick={async () => {
                                setIsLoading(true);
                                await onAdvertisementClick(item);
                              }}
                            >
                              <div
                                className="w-max basis-1/4 py-1 px-1 mr-1 bordrer-solid border-2 rounded"
                                style={handleStyleButtonByLandTypes(
                                  item.landTypeDesc
                                )}
                              >
                                <img
                                  src={
                                    item.image && item.image != ""
                                      ? item.image
                                      : noImageSvg
                                  }
                                  className="w-20 h-20 object-cover border-solid border-2 border-transparent rounded-lg bg-white"
                                />
                              </div>

                              <div
                                className={`${propertyAdvertisements.length == 1 &&
                                  "basis-3/4"
                                  } mr-1 bordrer-solid border-2 rounded py-1 px-1 border-transparent`}
                                style={{
                                  lineHeight: "normal",
                                  width:
                                    propertyAdvertisements.length > 1
                                      ? "60%"
                                      : "unset",
                                }}
                              >
                                <p
                                  className={`text-primaryColor100 mr-2 font-bold whitespace-nowrap`}
                                  style={{
                                    width: "10em",
                                    overflow: "auto",
                                    textOverflow: "auto",
                                  }}
                                >
                                  {" "}
                                  {item.propertyType
                                    ? item.propertyType
                                    : "غير محدد"}{" "}
                                  {item.landTypeDesc && "("}{" "}
                                  {item.landTypeDesc
                                    ? item.landTypeDesc
                                    : "غير محدد"}{" "}
                                  {item.landTypeDesc && ")"}
                                </p>

                                <p className="text-black mr-2">
                                  المساحة :{" "}
                                  {item.propertyArea == 0 ||
                                    item.propertyArea == null
                                    ? "غير محدد"
                                    : item.propertyArea}
                                </p>

                                <p className="text-redColor mr-2">
                                  {(() => {
                                    const price = item.propertyPrice ?? item.landTotalPrice;

                                    return price && price > 0
                                      ? `السعر: ${NumberWithCommas(price)}`
                                      : "";
                                  })()}
                                </p>

                              </div>

                              <div className="py-1 px-1 mr-1 bordrer-solid border-2 border-l-0 rounded-r-lg bg-primaryColor100">
                                <IonIcon
                                  icon={eye}
                                  style={{
                                    width: "25px",
                                    height: "5em",
                                    margin: "auto",
                                    color: "white",
                                  }}
                                />
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="w-auto flex flex-row justify-between items-center py-2 mt-2 animate__animated animate__jello">
                <div className="flex flex-row justify-start items-center">
                  <div className="flex flex-col justify-center items-center text-center ml-4">
                    <div
                      onClick={onWhatsAppClick}
                      className="w-11 h-9 rounded flex flex-col flex-auto justify-center items-center border-2 border-primaryColor100"
                    >
                      <IonIcon
                        icon={whatsappSvg}
                        style={{
                          color: "#0031c4",
                          fontSize: "large",
                          margin: "unset",
                        }}
                      ></IonIcon>
                    </div>
                    <p className="mt-px" style={{ fontSize: "15px" }}>
                      واتساب
                    </p>
                  </div>

                  <div className="flex flex-col justify-center items-center text-center ml-4">
                    <div
                      onClick={() => {
                        const centroid = property?.geometry ? getPolygonCenterPoint(property.geometry as any) : null;
                        if (centroid) {
                          showOnGoogleMapsFunction({ longitude: centroid.longitude, latitude: centroid.latitude });
                        }
                      }}
                      className="w-11 h-9 text-primaryColor100 rounded flex flex-col flex-auto justify-center items-center border-2 border-primaryColor100"
                    >
                      <IonIcon
                        icon={googleMapsSvg}
                        className="w-16 h-11"
                        style={{
                          color: "#0031c4",
                          fontSize: "large",
                          margin: "unset",
                        }}
                      ></IonIcon>
                    </div>
                    <p
                      className="mt-px"
                      style={{
                        fontSize: "14px",
                        width: "38px",
                        height: "24px",
                        lineHeight: "normal",
                      }}
                    >
                      جوجل ماب
                    </p>
                  </div>

                  {isUser || authenticationState == "unAuthenticated" ? (
                    <>
                      <div className="flex flex-col justify-center items-center text-center ml-4">
                        <div
                          onClick={() => {
                            if (authenticationState == "unAuthenticated") {
                              onSignInClick();
                            } else {
                              onCreateFavoriteLandClick();
                            }
                          }}
                          className="w-11 h-9 bg-primaryColor100 text-primaryColor100 rounded flex flex-col flex-auto justify-center items-center border-2 border-primaryColor100"
                        >
                          <IonIcon
                            icon={bookmarks}
                            style={{
                              color: "white",
                              fontSize: "large",
                              margin: "unset",
                            }}
                          ></IonIcon>
                        </div>
                        <p className="mt-px text-xl">مفضلة</p>
                      </div>
                    </>
                  ) : null}

                  <div className="flex flex-col justify-center items-center text-center ml-4">
                    <div
                      onClick={() => {
                        //showOnGoogleMapsFunction(getPolygonCenterPoint(property?.geometry as any));
                        setIsLoading(true);
                        routeLayer.removeAll();
                        routeParams.stops.features = [];
                        addStop(currentEventClick);
                      }}
                      className="w-11 h-9 bg-primaryColor100 text-primaryColor100 rounded flex flex-col flex-auto justify-center items-center border-2 border-primaryColor100"
                    >
                      <IonIcon
                        icon={navSvg}
                        style={{
                          color: "white",
                          fontSize: "large",
                          margin: "unset",
                        }}
                      ></IonIcon>
                    </div>
                    <p className="mt-px text-xl">تتبع</p>
                  </div>

                  <div className="flex flex-col justify-center items-center text-center ml-4">
                    <div
                      onClick={() => {
                        if (authenticationState == "unAuthenticated") {
                          onSignInClick();
                        } else {
                          onCreateBuildingsWalletClick();
                        }
                      }}
                      className="w-11 h-9 rounded flex flex-col flex-auto justify-center items-center border-2 border-primaryColor100"
                    >
                      <IonIcon
                        icon={walletSvg}
                        style={{
                          color: "#0031c4",
                          fontSize: "large",
                          margin: "unset",
                        }}
                      ></IonIcon>
                    </div>
                    <p className="mt-px" style={{ fontSize: "15px" }}>
                      محفظة
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonModal>
    </>
  );
};

export default PropertyModal;
